import React, {useState} from 'react'
import projects from '../components/allProjects'
import Title from '../components/Title'
import Categories from '../components/Categories'
import ProjectItems from '../components/ProjectItems'

const allCategories = ['All', ...new Set(projects.map((project) => project.category))];

const Projects = () => {

    const [projectItems, setProjectItems] = useState(projects)
    const [categories, setCategories] = useState(allCategories)

    const filter = (category) => {

        if(category === 'All') {

            setProjectItems(projects)
            return;

        }

        const filteredProjects = projects.filter((item) => item.category === category)

        setProjectItems(filteredProjects)

    }

    return (
        <div className="ProjectPage">
            <div className="p-title">
                 <Title title={'Projects'} span={'Projects'} />
            </div>
            <div>
                <Categories filter={filter} categories={categories} />
                <ProjectItems projectItems={projectItems} />
            </div>
        </div>
    )


}

export default Projects